<template>
    <div class="estratti-conto-detail" v-if="!deleted">
      <div class="grid" v-if="estrattoConto">
        <div class="col">
          <div  class="card mb-0">
            <div class="flex justify-content-between mb-3">
              <div>
                <span class="block text-500 font-medium mb-1 title-detail">IMPORTO</span>
                <div class="text-900 font-medium text-xl">
                  <div class="importo">{{formatCurrency(estrattoConto.value.toFixed(2))}}
                    <span class="pi pi-euro"></span>
                  </div>
                </div>
              </div>
              <div class="flex align-items-center justify-content-center bg-blue-100 border-round" style="width:2.5rem;height:2.5rem">
                <i class="pi pi-euro text-blue-500 text-xl"></i>
              </div>
            </div>
            <hr>
            <div class="grid">
              <div class="col-6">
                <p class="block text-500 font-medium mb-1 title-detail"> DATA VALUTA</p>
                <b>{{formatDate(estrattoConto.data_valuta)}}</b>
              </div>
              <div class="col-6">
                <p class="block text-500 font-medium mb-1 title-detail">DATA CONTABILE</p>
                <b>{{formatDate(estrattoConto.data_contabile)}}</b>
              </div>
              <div class="col-6">
                <p class="block text-500 font-medium mb-1 title-detail">BANCA</p>
                <b>{{estrattoConto.type_pay_mode_name}}</b>
              </div>
              <div class="col-6">
                <p class="block text-500 font-medium mb-1 title-detail">TIPOLOGIA</p>
                <b>{{estrattoConto.type_pay_name}}</b>
              </div>
              <div class="col-12">
                <p class="block text-500 font-medium mb-1 title-detail">DESCRIZIONE</p>
                <b>{{estrattoConto.descrizione}}</b>
              </div>
            </div>
            
            <div class="flex justify-content-end mt-4">
              <Button @click="confirmDelete" label="Elimina movimento" class="p-button-outlined p-button-danger"  />
            </div>
          </div>
        </div>

        <!-- Card appear only movement are splitted -->
        <div v-if="newIdSplitted && newEstrattoContoSplitted" class="col new-splitted">
          <div @click="closeNewSplitted" class="btn-close-split"><i class="pi pi-times"></i></div>
          <div  class="card mb-0 bg-gray-200">
            <div class="flex justify-content-between mb-3">
              <div>
                <span class="block text-500 font-medium mb-1 title-detail">IMPORTO</span>
                <div class="text-900 font-medium text-xl">
                  <div class="importo">{{newEstrattoContoSplitted.value}}
                    <span class="pi pi-euro"></span>
                  </div>
                </div>
              </div>
              <div class="flex align-items-center justify-content-center bg-blue-100 border-round" style="width:2.5rem;height:2.5rem">
                <i class="pi pi-euro text-blue-500 text-xl"></i>
              </div>
            </div>
            <hr>
            <div class="grid">
              <div class="col-6">
                <p class="block text-500 font-medium mb-1 title-detail"> DATA VALUTA</p>
                <b>{{newEstrattoContoSplitted.data_valuta}}</b>
              </div>
              <div class="col-6">
                <p class="block text-500 font-medium mb-1 title-detail">DATA CONTABILE</p>
                <b>{{newEstrattoContoSplitted.data_contabile}}</b>
              </div>
              <div class="col-6">
                <p class="block text-500 font-medium mb-1 title-detail">BANCA</p>
                <b>{{newEstrattoContoSplitted.type_pay_mode_name}}</b>
              </div>
              <div class="col-6">
                <p class="block text-500 font-medium mb-1 title-detail">TIPOLOGIA</p>
                <b>{{newEstrattoContoSplitted.type_pay_name}}</b>
              </div>
              <div class="col-12">
                <p class="block text-500 font-medium mb-1 title-detail">DESCRIZIONE</p>
                <b>{{newEstrattoContoSplitted.descrizione}}</b>
              </div>
            </div>
            
            <div class="flex justify-content-end mt-4">
              <Button @click="goToNewDetail(newEstrattoContoSplitted.id)" label="Visualizza movimento" class="p-button-outlined p-button-primary"  />
            </div>
          </div>
        </div>

        
        
        <Accordion :activeIndex="0" class="mt-3 card col-12">
          <AccordionTab header="ASSOCIA">
            <div class="grid mt-1">
              
              <div class="col-12">
                <Dropdown v-model="selectedAssociate" :options="type_associates" optionLabel="name" optionValue="val" :optionDisabled="option => option.val === 'movimento_ignoto' && estrattoConto.is_movimento_ignoto" placeholder="Seleziona" class="inputfield w-full" />
                <Message v-if="estrattoConto.is_movimento_ignoto" severity="info" :closable="false" class="mt-2">
                  Questo movimento è già stato classificato come movimento ignoto.
                </Message>
              </div>

              <!-- fatture vendita -->
              <div class="col-12" v-if="selectedAssociate == 'fatture-vendita'" style=" position:relative">
                <Fatture :detail="estrattoConto" :type="selectedAssociate" @movement-regularized="goPrevNextDetail($event)" />
              </div>

              <!-- fatture acquisto -->
              <div class="col-12" v-if="selectedAssociate == 'fatture-acquisto'" style=" position:relative">
                <Fatture :detail="estrattoConto" :type="selectedAssociate" @movement-regularized="goPrevNextDetail($event)" />
              </div>

              <!-- rappresentante -->
              <div class="col-12" v-if="selectedAssociate == 'rappresentante'" style=" position:relative">
                <Rappresentante :detail="estrattoConto" @movement-regularized="goPrevNextDetail($event)" />
              </div>

              <!-- cliente -->
              <div class="col-12" v-if="selectedAssociate == 'cliente'" style=" position:relative">
                <Cliente :detail="estrattoConto" @movement-regularized="goPrevNextDetail($event)" />
              </div>

              <!-- fornitore -->
              <div class="col-12" v-if="selectedAssociate == 'fornitore'" style=" position:relative">
                <Fornitore :detail="estrattoConto" @movement-regularized="goPrevNextDetail($event)" />
              </div>

              <!-- giroconto -->
              <div class="col-12" v-if="selectedAssociate == 'giroconto'" style=" position:relative">
                <Giroconto :detail="estrattoConto" @movement-regularized="goPrevNextDetail($event)" />
              </div>

              <!-- conto acquisto -->
              <div class="col-12" v-if="selectedAssociate == 'conto-acquisto'" style=" position:relative">
                <ContoAcquisto :detail="estrattoConto" @movement-regularized="goPrevNextDetail($event)" />
              </div>

              <!-- commercialista -->
              <div class="col-12" v-if="selectedAssociate == 'commercialista'" style=" position:relative">
                <Commercialista :detail="estrattoConto" @movement-regularized="goPrevNextDetail($event)" />
              </div>

              <!-- rid -->
              <div class="col-12" v-if="selectedAssociate == 'rid'" style=" position:relative">
                <Rid :detail="estrattoConto" @movement-regularized="goPrevNextDetail($event)" />
              </div>

              <!-- movimento ignoto -->
              <div class="col-12" v-if="selectedAssociate == 'movimento_ignoto' && !estrattoConto.is_movimento_ignoto" style=" position:relative">
                <MovimentoIgnoto :detail="estrattoConto" @movement-regularized="goPrevNextDetail($event)" />
              </div>
            </div>
          </AccordionTab>
        </Accordion>

        
        <Accordion class="mt-3 card col-12">
            <AccordionTab header="DIVIDI">     
            <div class="formgrid grid">
              <div class="field col-12 md:col-6">
                <label for="types_pay">Tipologia</label>
                <Dropdown id="types_pay" v-model="selectedTypePaySplitted" :filter="true" :options="typesPay" optionLabel="name" optionValue="id" placeholder="Tipologia" class="inputfield w-full" :class="{'p-invalid': validationErrors.type_pay_split && submitted }" />
                <small class="p-error" v-if="validationErrors.type_pay_split && submitted">Il campo è richiesto</small>
              </div>
              <div class="field col-12 md:col-6">
                <label for="importo">Importo</label> <br>
                
                <div class="input-icon-left w-full flex align-items-center">
                    <i  class="p-error mr-2" :class="estrattoConto.value >= 0 ? 'pi pi-plus ' : 'pi pi-minus'  " style="fontSize: 0.6rem" />
                    <InputNumber id="importo" v-model="importoSplitted" mode="decimal" :minFractionDigits="2" :maxFractionDigits="2" class="inputfield w-full" :class="{'p-invalid': validationErrors.importo_split || validationErrors.importo_split_too_big && submitted }" />
                </div>
                <small class="p-error" v-if="validationErrors.importo_split && submitted">Il campo è richiesto</small>
                <small class="p-error" v-if="validationErrors.importo_split_too_big && submitted">Il valore non può essere maggiore o uguale di {{estrattoConto.value}}</small>
              </div>
              <div class="field col-12 md:col-12">
                <label for="descrizione">Descrizione</label>
                <Textarea id="descrizione" v-model.trim="descrizioneSplitted" rows="5" class="inputfield w-full" :class="{'p-invalid': validationErrors.descrizione_split && submitted }" />
                <small class="p-error" v-if="validationErrors.descrizione_split && submitted">Il campo è richiesto</small>
              </div>
            </div>
            <div class="flex justify-content-end mt-4">
              <Button @click="confirmSplitted" label="Dividi movimento" class="p-button-outlined p-button-primary"  />
            </div>
        
            </AccordionTab>
        </Accordion>

        <Accordion class="mt-3 card col-12" @tab-open="runCheckEstrattiConto">
          <AccordionTab header="CHECK ESTRATTI CONTO">
            <div v-if="checkEstrattiLoading" class="text-center py-3">
              <i class="pi pi-spin pi-spinner text-primary" style="font-size: 1.5rem"></i>
            </div>

            <div v-else-if="checkEstrattiDone && checkEstrattiRows.length === 0" class="text-center text-500 py-3">
              Nessun estratto conto trovato
            </div>

            <DataTable
              v-else-if="checkEstrattiRows.length > 0"
              :value="checkEstrattiRows"
              dataKey="cod_estrattoconto"
              responsiveLayout="scroll"
              :rowClass="() => 'cursor-pointer'"
              @row-click="onCheckEstrattoRowClick"
            >
              <Column field="cod_estrattoconto" header="Estratto conto">
                <template #body="{ data }">
                  <button
                    type="button"
                    class="check-ec-link"
                    @click.stop="goToCheckedEstrattoConto(data)"
                  >
                    <i class="pi pi-external-link"></i>
                    {{ data.cod_estrattoconto }}
                  </button>
                </template>
              </Column>
              <Column field="numero" header="Fattura" />
              <Column field="value" header="Importo">
                <template #body="{ data }">
                  {{ Number(data.value).toFixed(2) }}
                </template>
              </Column>
              <Column field="data" header="Data" />
              <Column field="note" header="Note" />
              <Column header="Stato">
                <template #body="{ data }">
                  {{ Number(data.used) === 1 ? 'Regolarizzato' : 'Non regolarizzato' }}
                </template>
              </Column>
            </DataTable>
          </AccordionTab>
        </Accordion>
        

      </div>

      <div v-else class="card">
        <Skeleton class="mb-2"></Skeleton>
        <Skeleton width="100%" class="mb-2"></Skeleton>
        <Skeleton width="5rem" class="mb-2"></Skeleton>
        <Skeleton height="2rem" class="mb-2"></Skeleton>
        <Skeleton width="10rem" height="4rem"></Skeleton>
      </div>
    </div>
     <div v-else> <!-- -->
      <div  class="card mb-0">
        <div class="mb-4 flex justify-content-center">
          <div class="flex justify-content-center flex-column align-items-center">
            <div class="flex align-items-center justify-content-center bg-green-200 border-round mb-5" style="width:4.5rem;height:4.5rem">
              <i class="pi pi-check text-green-50 text-xl"></i>
            </div>
            Movimento eliminato o regolarizzato
          </div>
        </div>
        <router-link to="/estratti-conto"> 
          <span class="pi pi-arrow-left mr-2"></span> Torna ad estratti conto
        </router-link>
      </div>
    </div>
    

    <!-- DIALOG DELETE -->
    <Dialog v-model:visible="deleteDialog" :style="{width: '450px'}" header="Conferma eliminazione" :modal="true">
        <div class="confirmation-content flex align-items-center">
            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem; color: #EF4444" />
            <span v-if="estrattoConto">Confermi la cancellazione di questo movimento pari ad € <b>{{estrattoConto.value}}</b>  ?</span>
        </div>
        <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteDialog = false"/>
            <Button label="Si" icon="pi pi-check" class="p-button-text" @click="deleteSelected" />
        </template>
    </Dialog>

    <!-- DIALOG SPLIT -->
    <Dialog v-model:visible="splitDialog" :style="{width: '550px'}" header="Conferma" :modal="true">
        <div class="confirmation-content flex align-items-center">
           
            <div class="grid splitted"  v-if="estrattoConto">
              <div class="col-12 mb-2">
                Confermi la divisione di questo movimento in:
              </div>
              <div class="col-4">
                <small>IMPORTO ORIGINALE</small> 
              </div>
              <div class="col-8">
                <span class="splitted-import bg-blue-500">{{estrattoConto.value.toFixed(2)}}</span>
              </div>
              <div class="col-4">
                <small>Questo movimento</small> 
              </div>
              <div class="col-8">
                <span class="splitted-import">{{import1.toFixed(2)}}</span>
              </div>
              <div class="col-4">
                <small>Nuovo movimento</small> 
              </div>
              <div class="col-8">
                <span class="splitted-import">{{import2.toFixed(2)}}</span>
              </div>
            </div>

        </div>
        <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="splitDialog = false"/>
            <Button label="Si" icon="pi pi-check" class="p-button-text" @click="spiltMovement" />
        </template>
    </Dialog>


   

</template> 

<script>

import { ref, getCurrentInstance, onMounted } from 'vue';
import Service from '@/services/ask-pratiche/pratiche-service'
import {useRoute, useRouter} from 'vue-router';
import Fatture from '../unregularized/associa/Fatture.vue'
import Rappresentante from '../unregularized/associa/Rappresentante.vue'
import Cliente from '../unregularized/associa/Cliente.vue'
import Fornitore from '../unregularized/associa/Fornitore.vue'
import Giroconto from '../unregularized/associa/Giroconto.vue'
import ContoAcquisto from '../unregularized/associa/ContoAcquisto.vue'
import Commercialista from '../unregularized/associa/Commercialista.vue';
import Rid from '../unregularized/associa/Rid.vue';
import MovimentoIgnoto from '../unregularized/associa/MovimentoIgnoto.vue';

export default {

    components: {
        Fatture,
        Rappresentante,
        Cliente,
        Fornitore,
        Giroconto,
        ContoAcquisto,
        Commercialista,
        Rid,
        MovimentoIgnoto
    },
    setup() {
  
      const route = useRoute()
      const router = useRouter()
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http
      const formatDate = self.appContext.config.globalProperties.$formatDate
      const service = new Service(self.$http, self.$eventBus)
      const idEstrattoConto = route.params.id
      const estrattoConto = ref(null)
      const deleteDialog = ref(false);
      const splitDialog = ref(false);
      const deleted = ref(false);
      const typesPay = ref([])
      const selectedTypePaySplitted = ref('')
      const importoSplitted = ref(0)
      const descrizioneSplitted = ref()
      const validationErrors = ref({})
      const submitted = ref(false);
      const import1 = ref();
      const import2 = ref();
      const newIdSplitted = ref(null);
      const newEstrattoContoSplitted = ref(null)
      const selectedAssociate = ref('')
      const checkEstrattiRows = ref([])
      const checkEstrattiLoading = ref(false)
      const checkEstrattiDone = ref(false)
      const type_associates = ref([
        {
          name: 'Fatture Vendita',
          val:  'fatture-vendita',
        },
        {
          name: 'Fatture Acquisto',
          val:  'fatture-acquisto',
        },
        {
          name: 'Rappresentante',
          val:  'rappresentante',
        },
        {
          name: 'Cliente',
          val:  'cliente',
        },
        {
          name: 'Fornitore',
          val:  'fornitore',
        },
        {
          name: 'Giroconto',
          val:  'giroconto',
        },
        {
          name: 'Conto Acquisto',
          val:  'conto-acquisto',
        },
        {
          name: 'Commercialista',
          val:  'commercialista',
        },
        {
          name: 'Rid',
          val:  'rid',
        },
        {
          name: 'Movimento ignoto - da associare manualmente',
          val:  'movimento_ignoto',
        },
      ])

      onMounted(() => {
        getTypesPay()
        getData()
      })

      const getData = (newId = null) => {
        service.getEstrattoConto(idEstrattoConto).then((res) => {
          if (res.items.length) {
            estrattoConto.value = res.items[0]
            estrattoConto.value.used == 1 ? deleted.value = true : deleted.value = false
            descrizioneSplitted.value = estrattoConto.value.descrizione
            addRidToDropdown()
          } else {
            deleted.value = true
          }  
        })
        if (newIdSplitted.value) {
          service.getEstrattoConto(newId).then((res) => {
            newEstrattoContoSplitted.value = res.items[0]
          })
        }
      }

      const addRidToDropdown = () => {
        if (estrattoConto.value.type_pay_name == 'RID') {
          type_associates.value.push({name: 'Rid',val:  'rid'})
          selectedAssociate.value = 'rid'
        }    
      }

      const getTypesPay = () => {
        service.getTypesPay().then((res)=> {
          typesPay.value = res.items
        })
      }
      
      
      const confirmDelete = () => {
            deleteDialog.value = true;
      };

      const deleteSelected = () => {
        if (estrattoConto.value) {
          service.deleteEstrattiConto([estrattoConto.value]).then(() => {
              deleted.value = true
              // router.push("/estratti-conto")
          }).finally(()=>{ 
              deleteDialog.value = false;
          });  
        }
      }

      

      const confirmSplitted = () => {
        submitted.value = true;
        import1.value = null
        import2.value = null
        if (validateSplit()) {

          import1.value = parseFloat(estrattoConto.value.value)
          import2.value = importoSplitted.value

          if (estrattoConto.value.value < 0 ) {
            import2.value = - 1 * (Math.abs(import2.value))
          }
          import1.value = import1.value - import2.value
          splitDialog.value = true;
        }
      }

      const spiltMovement = () => { 
        if (import1.value != null && import2.value != null) {
          
          service.splitMovements(
            estrattoConto.value.id,
            import1.value, 
            import2.value,
            descrizioneSplitted.value,
            selectedTypePaySplitted.value,
            estrattoConto.value.cod_type_pay_mode,
            estrattoConto.value.data_contabile,
            estrattoConto.value.data_valuta,
          ).then((res) => {
            
            splitDialog.value = false;
            selectedTypePaySplitted.value = '';
            importoSplitted.value = null
            newIdSplitted.value = res.itemId
            getData(newIdSplitted.value)
            window.scrollTo({top: 0,left: 0,behavior: 'smooth'});
          })
        }  
      }

      const closeNewSplitted = () => {
        newIdSplitted.value = null
      }

      const goToNewDetail = (id) => {
        if (newIdSplitted.value) {
          let url = `/estratti-conto/detail/not-regularized/${id}`
          window.open(url, '_blank')
          window.open('','_self').close()
        }
      }

      const goPrevNextDetail = (evt) => {
        let idEstrattoConto = evt.id
        router.push({ path: `/estratti-conto/detail/prev-next/${idEstrattoConto}`})
      }

      const runCheckEstrattiConto = async () => {
        if (!estrattoConto.value || checkEstrattiLoading.value) return
        checkEstrattiLoading.value = true
        checkEstrattiDone.value = false
        try {
          const res = await service.checkEstrattiConto(estrattoConto.value)
          checkEstrattiRows.value = Array.isArray(res?.items) ? res.items : []
        } catch (e) {
          checkEstrattiRows.value = []
        } finally {
          checkEstrattiLoading.value = false
          checkEstrattiDone.value = true
        }
      }

      const goToCheckedEstrattoConto = (row) => {
        const cod = row?.cod_estrattoconto
        if (!cod) return
        const path = Number(row.used) === 1
          ? `/estratti-conto/detail/regularized/${cod}`
          : `/estratti-conto/detail/not-regularized/${cod}`
        window.open(path, '_blank')
      }

      const onCheckEstrattoRowClick = (event) => {
        goToCheckedEstrattoConto(event.data)
      }

      const validateSplit = () => {
        
        if (selectedTypePaySplitted.value == null || selectedTypePaySplitted.value == '')
            validationErrors.value['type_pay_split'] = true;
        else 
            delete validationErrors.value['type_pay_split'];

        if (importoSplitted.value == '')
            validationErrors.value['importo_split'] = true;
        else 
            delete validationErrors.value['importo_split'];

        let tempSplit = Math.abs(importoSplitted.value)
        let tempVal = Math.abs(estrattoConto.value.value)
    
        if (parseFloat(tempSplit) >= tempVal)
          validationErrors.value['importo_split_too_big'] = true;
        else 
          delete validationErrors.value['importo_split_too_big'];
        
       
        if (descrizioneSplitted.value == '')
            validationErrors.value['descrizione_split'] = true;
        else 
            delete validationErrors.value['descrizione_split'];

        return !Object.keys(validationErrors.value).length;
      }

      const formatCurrency = (value) => {
        value = parseFloat(value)
        return value.toLocaleString('it-IT')
      };
      

      return { 
        estrattoConto, confirmDelete, deleteDialog, deleteSelected, deleted, 
        typesPay, selectedTypePaySplitted, importoSplitted, descrizioneSplitted, confirmSplitted, 
        splitDialog, spiltMovement, validationErrors, submitted, import1, import2, newIdSplitted,
        newEstrattoContoSplitted, goToNewDetail, closeNewSplitted, type_associates, selectedAssociate,
        goPrevNextDetail, formatCurrency, formatDate,
        checkEstrattiRows, checkEstrattiLoading, checkEstrattiDone,
        runCheckEstrattiConto, goToCheckedEstrattoConto, onCheckEstrattoRowClick,
      }

    }
}
</script>

<style scoped>
.importo {
  font-size: 3.5rem;
  color: var(--blue-500);
}
.splitted-import {
  background: var(--yellow-500);
  font-size: 15px;
  padding: 4px 28px;
  border-radius: 7px;
  color: white;
  font-size: 14px;
  font-weight: bold;
}

.splitted .col-4 {
  border: 1px solid rgba(170, 170, 170, 0.1);
}
.new-splitted {
  position: relative;
}
.btn-close-split {
  cursor: pointer;
  position: absolute;
  top: -12px;
  right: -12px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background: var(--bluegray-100);
  border-radius: 50%;
}

.title-detail {
  font-size: 10px;
  letter-spacing: 2px;
}

.check-ec-link {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border: 0;
  background: transparent;
  color: #1f6c9f;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.9rem;
  padding: 0;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.check-ec-link:hover {
  color: #15557d;
}

:deep(.cursor-pointer) {
  cursor: pointer;
}

</style>

<style>
.bg-red-500 {
  background-color:#f44336 ;
}
.text-red-500 {
  color: #f44336 ;
}

.estratti-conto-detail .p-reset {
  cursor: pointer;
  font-size: 11px;
  border: 1px solid #f44336;
  padding: 6px 10px;
  border-radius: 4px;
}

.p-bar {
  -webkit-transition : width 2s ease;
  -moz-transition : width 2s ease;
  -o-transition : width 2s ease;
  transition : width 2s ease;
}
.chip-selected-suggest .p-chips-multiple-container{
  background: #cfcfcf !important;
}
.chip-selected-suggest .p-chips-token{
  position: relative;
  background: transparent !important;
  padding: 0px !important;
}
.chip-selected-suggest .title-chip {
  font-size: 11px;
}
.chip-selected-suggest .p-chips-token-icon {
  position: absolute !important;
  top: 0!important;
  right: -5px!important;
}

.chip-selected-suggest .p-chips-token .chip-basic {
  cursor:pointer;
  background: #fbc02d !important;
  margin-bottom: 4px !important;
  border-radius: 8px!important;
  padding: 0.25rem 1.4rem !important;
}
.chip-selected-suggest .p-chips-token .chip-special {
  
  background: #6bcdf3 !important;
  margin-bottom: 4px !important;
  border-radius: 8px!important;
  padding: 0.25rem 1.4rem !important;
}
.chip-selected-suggest .p-chips-token .chip-special + .p-chips-token-icon {
  display: none !important;
}
.title-bar {
  font-size: 10px;
  font-weight: 400;
  margin-bottom: 2px;
}
.num-bar {
  font-size: 18px;
}

.chip-selected-suggest{
  display: block;
  width: 100% !important;
}


.icon-edit-saldo {
  cursor: pointer;
}
</style>
